import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import UserSettingsLayout from 'components/user-settings/UserSettingsLayout';
import AccountSettingsForm from 'components/user-settings/AccountSettingsForm';
import { UserSettingsRouteV2Id } from 'routes/routesConfigV2';
import UserDetailsPageStore, {
  AccountSettingsPageStoreContext,
  useAccountSettingsPageStore,
} from 'store/pages/user-settings/account-settings/pageStore';
import { Button } from '@insurancemenu/imenu-components-lib';
import { FooterStyled } from './styles';

const PageContent: React.FC = observer(() => {
  const { isInitialDataLoading, isActionLoading, canComplete, getInitialData, updateUserInfo } =
    useAccountSettingsPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <UserSettingsLayout
      pageId={UserSettingsRouteV2Id.ACCOUNT_SETTINGS}
      isInitialLoading={isInitialDataLoading}
      isActionLoading={isActionLoading}
      pageFooter={
        <FooterStyled>
          <Button color="primary" size="large" disabled={!canComplete} onClick={updateUserInfo}>
            Update
          </Button>
        </FooterStyled>
      }
    >
      <AccountSettingsForm />
    </UserSettingsLayout>
  );
});

const AccountSettingsPage: React.FC = () => {
  const pageStore = useMemo(() => new UserDetailsPageStore(), []);

  return (
    <AccountSettingsPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </AccountSettingsPageStoreContext.Provider>
  );
};

export default AccountSettingsPage;
